(function ($) {
    $(function () {
        var $memberMap = $('#member-map');

        if (!$memberMap.length) {
            return;
        }

        $memberMap.on('click', '.state', function () {
            var stateId = $(this).data('state');
            window.location.href = (window.ld.homeUrl + "/" + window.ld.membersPageSlug + "/state/" + stateId);
        });

        var stateMemberNumbers = {};
        // Get member data and prcoess it
        $memberMap.data('state-members').split(',').forEach(function (data) {
            var stateData = data.split('=');
            stateMemberNumbers[stateData[0].toLowerCase()] = parseInt(stateData[1]);
        });

        $.each(stateMemberNumbers, function (stateName, stateMemberNumber) {
            // Get X translation based on number of digits
            var $digitCount = stateMemberNumber.toString().length;

            var $translationX = "";
            if ($digitCount === 2) {
                $translationX = '-42px';
            } else if ($digitCount === 3) {
                $translationX = '-76px';
            } else if ($digitCount === 4) {
                $translationX = '-115px';
            } else if ($digitCount > 4) {
                $translationX = '-154px';
            }

            var $state = $memberMap.find('.state[data-state="' + stateName + '"]');

            // set number and xtranslation
            $state.find('.state-member-number')
                .css('transform', 'translateX(' + $translationX + ')')
                .find('text').text(stateMemberNumber);

            // deplurarlise heading
            if (stateMemberNumber === 1) {
                $state.find('.state-member-name text').text($state.find('.state-member-name text').text().replace("MEMBERS", "MEMBER"));
            }
        });
    });
})(jQuery);
